import { TextField, TextFieldProps } from "@mui/material";
import { FC, useState } from "react";

interface EmailFormProps
  extends Omit<TextFieldProps, "onChange" | "value" | "defaultValue"> {
  onChange?: (phone: string | undefined) => void;
  isValid?: (isValid: boolean) => void;
  defaultValue?: string;
}

/**
 * Passes a validated email, or undefined
 * @param onChange passes new value (or undefined) as a property
 * @param isValid returns true if input is valid, otherwise false
 * @param defaultValue sets the initial value on first render
 */
const EmailForm: FC<EmailFormProps> = ({
  onChange,
  isValid,
  defaultValue,
  autoFocus,
  label,
  ...textFieldProps
}) => {
  const [valid, setValid] = useState(true);
  const [lastValue, setLastValue] = useState("");

  const validateAndSubmit = (newValue: string) => {
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newValue);
    if (isValidEmail) {
      if (onChange && lastValue != newValue) onChange(newValue);
      setValid(true);
      if (isValid) isValid(true);
      setLastValue(newValue);
    } else {
      if (onChange && lastValue != newValue) onChange(undefined);
      setValid(false);
      if (isValid) isValid(false);
      setLastValue(newValue);
    }
  };

  return (
    <TextField
      fullWidth
      id="email-field"
      autoFocus={autoFocus}
      defaultValue={defaultValue}
      label={label || "Enter Email"}
      color={valid ? "primary" : "error"}
      onChange={(e) => validateAndSubmit(e.target.value)}
      {...textFieldProps}
    />
  );
};

export default EmailForm;
